import { render } from "./ImportAmazeQuote.vue?vue&type=template&id=a76ff48e"
import script from "./ImportAmazeQuote.vue?vue&type=script&lang=js"
export * from "./ImportAmazeQuote.vue?vue&type=script&lang=js"

import exportComponent from "/Users/souban/Documents/Code/Pitch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__